export interface BundleTextType {
    parentVariantId?: string;
    subs?: BundleItemType[];
    link_buy?: string;
    power?: string;
    desc?: string;
    quantity?: number;
    tip?: string;
    btn?: string;
}

export interface ProductAPIType {
    variantId: string;
    productId: string;
    sku: string;
    inventoryQuantity: number;
    inventoryPolicy: string;
    price: number;
    compareAtPrice: number;
    img: string;
    variantImg: string;
    productTitle: string;
    skuTitle: string;
    handle: string;
}

export interface BundleItemType extends Partial<ProductAPIType>, BundleTextType {}

export interface BundleIdsType {
    [key: string]: BundleItemType[];
}

// 正式阶段bundleId
export const bundleIds: BundleIdsType = {
    us: [
        {
            productId: '15391292588105',
            variantId: '54714781204553',
            subs: [
                {
                    productId: '15392480264265',
                    variantId: '54720265257033',
                },
                {
                    productId: '6970777174089',
                    variantId: '54572871614537',
                },
                {
                    productId: '15392477970505',
                    variantId: '54720259293257',
                },
                {
                    productId: '15343862284361',
                    variantId: '54720237437001',
                },
                {
                    productId: '15343862284361',
                    variantId: '54732545228873',
                },
            ],
        },
        {
            productId: '15391302418505',
            variantId: '54714805551177',
            subs: [
                {
                    productId: '15343862284361',
                    variantId: '54720237437001',
                },
                {
                    productId: '15343862284361',
                    variantId: '54732545228873',
                },
            ],
        },
    ],
};

// 预热阶段bundleIds
export const bundleIdsTeaser: BundleIdsType = {
    us: [
        {
            productId: '15391292588105',
            variantId: '54720023330889',
            btn: 'Deposit Now',
            link_buy: 'https://us.ecoflow.com/products/delta-pro-ultra-x',
        },
        {
            productId: '15391292588105',
            variantId: '54720023330889',
            btn: 'Deposit Now',
            link_buy: 'https://us.ecoflow.com/products/delta-pro-ultra-x',
        },
    ],
};
